







































































import { Component, Prop, Mixins } from "vue-property-decorator";

import BaseButton from "@/components/BaseButton/BaseButton.vue";
import AsyncButton from "@/components/BaseAsyncButton/BaseAsyncButton.vue";
import BaseDropdown from "@/components/BaseDropdown/BaseDropdown.vue";
import InputRow from "@/components/InputRow/InputRow.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";
import AppContent from "@/components/AppContent/AppContent.vue";

import RequestState from "@/utils/mixins/RequestState";

import { LessonsFormData } from "./Lessons.vue";
import { ILesson } from "@/models/interfaces/lessons";
import { ISchool } from "@/models/interfaces/schools";
import { IVuexState } from "@/models/interfaces/store";
import { IClass } from "@/models/interfaces/classes";
import { IDropdownItem } from "@/models/interfaces/dropdown";

@Component({
  components: {
    BaseButton,
    BaseDropdown,
    InputRow,
    AsyncButton,

    AppHeaderBackWithTitle,
    AppHeader,
    AppContent
  }
})
export default class LessonsStep1View extends Mixins(RequestState) {
  @Prop({ required: true })
  private form!: LessonsFormData;

  @Prop({ required: true })
  private schools!: IVuexState<ISchool[]>;

  @Prop({ required: true })
  private classes!: IVuexState<IClass[]>;

  @Prop({ required: true })
  private lessons!: IVuexState<ILesson[]>;

  private pending = false;

  private get disabled() {
    return !this.form.schoolsIds.length || !this.form.classesIds.length;
  }

  get schoolsOptions() {
    return this.schools.data?.map(school => ({
      label: school.schoolName,
      value: school.schoolId
    }));
  }

  get subGroupsOptions() {
    return this.form.classesIds.reduce<IDropdownItem[]>((result, classId) => {
      const relatedSubgroups =
        this.classes.data?.find(item => item.classId === classId)?.subGroups ??
        [];

      return [
        ...result,
        ...relatedSubgroups.map(subGroup => ({
          label: subGroup.name,
          value: subGroup.subGroupId
        }))
      ];
    }, []);
  }

  get classesOptions() {
    return this.classes.data?.map(classData => ({
      label: classData.className,
      value: classData.classId
    }));
  }

  private setAutoSetupLoadingState(status: boolean) {
    this.pending = status;
  }

  private handleSubmit(setupType: "auto" | "manual") {
    if (!this.disabled) {
      this.$emit("on-next", setupType);
    }
  }
}
